import { loginUser } from '../api';
import { Env } from '@/shared/config/environment';
import { LocalStore } from '@/shared/lib/local-storage';

const state = {
  accessToken: null,
  userData: null,
  isLoadingUserData: false,
  isLoginFail: false,
  failMessage: null,
};

const mutations = {
  SET_ACCESS_TOKEN: (state, accessToken) => {
    state.accessToken = accessToken;
    new LocalStore().set('token', accessToken);
  },
  SET_USER_DATA: (state, userData) => {
    state.userData = userData;
    new LocalStore().set('info', userData);
  },
  SET_LOADING_USER_DATA: (state, isLoading) => {
    state.isLoadingUserData = isLoading;
  },
  SET_LOGIN_FAIL: (state, isLoginFail) => {
    state.isLoginFail = isLoginFail;
  },
  SET_LOGIN_FAIL_MESSAGE: (state, message) => {
    state.failMessage = message;
  },
};

const actions = {
  async login({ commit, dispatch }, { email, password }) {
    commit('SET_LOADING_USER_DATA', true);
    commit('SET_LOGIN_FAIL', false);
    commit('SET_ACCESS_TOKEN', null);

    try {
      const userData = await loginUser({ email, password });
      commit('SET_ACCESS_TOKEN', userData?.token);
      commit('SET_USER_DATA', userData?.info);

      return userData;
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вірний email користувача або пароль';

      commit('SET_LOGIN_FAIL', errorMessage);
      commit('SET_ACCESS_TOKEN', null);

      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вірний email користувача або пароль',
          message: errorMessage,
        }, { root: true });
      }

      const responseCode = error?.response?.status || 0;
      if (responseCode === 401) {
        commit('SET_LOGIN_FAIL_MESSAGE', 'Неправильний email або пароль');
      } else if (responseCode >= 500) {
        commit('SET_LOGIN_FAIL_MESSAGE', 'Внутрішня помилка сервера. Спробуйте, будь ласка через кілька хвилин.');
      }

      throw error;
    } finally {
      commit('SET_LOADING_USER_DATA', false);
    }
  },
  clearError({ commit }) {
    commit('SET_LOGIN_FAIL', null);
  },
};

const getters = {
  isLoadingUserData: state => state.isLoadingUserData,
  isLoginFail: state => state.isLoginFail,

  isUserLoggedIn: state => { return state.isLoadingUserData === false && state.userData !== null; },
  getAccessToken: state => state.accessToken,
  getUserInfo: state => state.userData,
  getFailMessage: state => state.failMessage,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
